module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('p', {
    staticClass: "c12"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('strong', {
    staticClass: "calibre1"
  }, [_vm._v("CHRONOLOGY")])]), _vm._v(" "), _c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "c19",
    staticStyle: {
      "width": "100%",
      "font-size": "1em"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "t349_firstrow",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c20",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("11 September 1885")]), _vm._v(" "), _c('td', {
    staticClass: "c21",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Born in Eastwood, Nottinghamshire")])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1898–July 1901")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Pupil at Nottingham High School")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("1902–1908")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Pupil teacher; student at University College, Nottingham")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("7 December 1907")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("First publication: 'A Prelude', in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Nottinghamshire Guardian")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1908")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Appointed as teacher at Davidson Road School, Croydon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("November 1909")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Publishes five poems in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("English Review")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("3 December 1910")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Engagement to Louie Burrows; broken off on 4 February 1912")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 December 1910")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Death of his mother, Lydia Lawrence")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 January 1911")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The White Peacock")]), _vm._v(" published in New York (20 January in London)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 November 1911")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Ill with pneumonia; resigns his teaching post on 28 February 1912")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1912")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Meets Frieda Weekley; they elope to Germany on 3 May")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 May 1912")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Trespasser")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1912–March 1913")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Gargnano, Lago di Garda, Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February 1913")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Love Poems and Others")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("29 May 1913")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Sons and Lovers")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June–August 1913")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("August–September 1913")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Germany and Switzerland")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("30 September 1913–9 June 1914")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Lerici, Gulf of La Spezia, Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("1 April 1914")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Widowing of Mrs. Holroyd")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1914–December 1915")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In London, Buckinghamshire and Sussex")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("13 July 1914")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Marries Frieda Weekley in London")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("26 November 1914")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Prussian Officer and Other Stories")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("30 September 1915")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Rainbow;")]), _vm._v(" suppressed by court order on 13 November")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1916")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Twilight in Italy")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1916")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Amores")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("15 October 1917")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("After twenty-one months' residence in Cornwall, ordered to leave by military authorities")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1917–November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In London, Berkshire and Derbyshire")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v("26 November 1917")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Look! We Have Come Through!")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1918")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("New Poems")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("14 November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Travels to Italy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("15–17 November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Val Selice, near Turin")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 November–10 December 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At the Pensione Balestra, Florence; probably writes 'David' and 'Looking Down on the City' (between November 1919 and May 1921)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("20 November 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Bay")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("13–22 December 1919")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Picinisco")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1920–February 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Fontana Vecchia, Taormina, Sicily")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("May 1920")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Touch and Go")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1920")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Villa Canovaia, San Gervasio, Florence; the poem 'Cypresses' written at Fiesole")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 November 1920")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Private publication of "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Women in Love")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 November 1920")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Lost Girl")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("5–13 January 1921")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Visits Sardinia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("April 1921")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("To Germany via Capri, Rome and Florence; on Capri meets Earl and Achsah Brewster; in Florence meets Rebecca West")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("May 1921")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes the chapters 'Florence' and 'High Up over the Cathedral Square' "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("of Aaron's Rod")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 May 1921")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Psychoanalysis and the Unconscious")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("12 December 1921")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Sea and Sardinia")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("26 February 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Leaves for Ceylon")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March–August 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Ceylon and Australia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("14 April 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Aaron's Rod")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1922–March 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In New Mexico")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 October 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Fantasia of the Unconscious")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("24 October 1922")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("England, My England")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Ladybird, The Fox, The Captain's Doll")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March–November 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Mexico and USA")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("27 August 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Studies in Classic American Literature")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Kangaroo")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 October 1923")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Birds, Beasts and Flowers")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("December 1923–March 1924")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England, France and Germany")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1924–September 1925")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In New Mexico and Mexico")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("28 August 1924")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Boy in the Bush")]), _vm._v(" (with Mollie Skinner)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 September 1924")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Death of his father, John Arthur Lawrence")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v("14 May 1925")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("St. Mawr together with the Princess")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September–November 1925")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In England and Germany")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("15 November 1925–20 April 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Spotorno (Liguria), and at Villa Bernarda from 23 November")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Late November 1925")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes 'Europe Versus America'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("7 December 1925")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Reflections on the Death of a Porcupine")]), _vm._v(" (Philadelphia)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("21 January 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Plumed Serpent")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March–April 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Begins to plan to visit Etruria")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Late March 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("First visit to an Etruscan town, Perugia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 March 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("David")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("April 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Europe Versus America' in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Laughing Horse")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("May 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Reading Etruscan history in Mommsen, Weege, Ducati, Fell")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("6 May 1926–June 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At the Villa Mirenda, Scandicci (Florence)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 June 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Probably writes 'Fireworks'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Late June 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Probably writes 'The Nightingale'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July–September 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Germany and England")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October 1926–19 March 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Back at the Villa Mirenda")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October–November 1926")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes 'Man is a Hunter' and "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The First Lady Chatterley")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("December 1926–February 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("John Thomas and Lady Jane")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("New plan to visit the Etruscan places")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February–April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes 'Flowery Tuscany' I–III")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("22–8 March 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Ravello (Salerno) with the Brewsters")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("5 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Etruscan tour with Earl Brewster starts in Rome: visit to the Villa Giulia Museum")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("6 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Cerveteri")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("7–8 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Tarquinia")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("9 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Vulci")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At Volterra")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("11 April 1927–June 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("At the Villa Mirenda")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("16 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Fireworks' in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Nation & Athenœum")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("13–28 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes Part I of "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Escaped Cock")]), _vm._v(", 'from that toy in Volterra'")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("27–9 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Travel Sketches of Etruscan Places' begun; asks for copies of Dennis and Weege")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("30 April 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Suggests "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")]), _vm._v(" might publish the Etruscan sketches; probably writes 'Flowery Tuscany' IV")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Early May 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Probably writes 'Germans and English', later published by Insel-Verlag as 'Ein Brief von D.H. Lawrence an das Inselschiff' (Leipzig 1927); starts collecting photographs for the Etruscan book")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v("May 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Fireworks' in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Forum")]), _vm._v(" (New York)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Mornings in Mexico")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("6 June 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'About 80 pp. MSS.' written ('Cerveteri', 'Tarquinia', 'The Painted Tombs of Tarquinia' 1.)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("14 June 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Cerveteri' typed; 'The Painted Tombs of Tarquinia' 2. and 'Vulci' written. Sends 'Cerveteri' ('6000 words') and eight photographs to Curtis Brown")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("25 June 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Volterra' written")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("26 June–22 July 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("The other five Etruscan sketches are typed")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Plans a second Etruscan tour; 'The Florence Museum' possibly written July–October 1927")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("23 July 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Sends Curtis Brown the 'first' six Etruscan sketches and all the photographs")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("10 September 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The Nightingale' in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Spectator")]), _vm._v(" and also in the September "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Forum")]), _vm._v(" (a German translation, 'Die Nachtigall', published in the "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Insel-Almanach auf das Jahr 1928)")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("October–December 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Flowery Tuscany' I–III in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("New Criterion")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("November 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The City of the Dead at Cerveteri' ('Cerveteri') in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("December 1927")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The Ancient Metropolis of the Etruscans' ('Tarquinia') in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("December 1927–February 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Writes "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Lady Chatterley's Lover")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("January 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The Painted Tombs of Tarquinia' (1) in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The Wind-Swept Stronghold of Volterra' ('Volterra') in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("February–May 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("The same four Etruscan essays in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("World Today")]), _vm._v(" with DHL's titles")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("24 May 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Woman Who Rode Away and Other Stories")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("June 1928–March 1930")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("In Switzerland and, principally, in France")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Lady Chatterley's Lover")]), _vm._v(" privately published (Florence)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1928")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Collected Poems")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("March 1929")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Gives up the plan of writing more Etruscan sketches")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("April 1929")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'The Year in Flowery Tuscany' ('Flowery Tuscany' I–III) in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Travel")])])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("July 1929")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Exhibition of paintings in London raided by police; "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Pansies")]), _vm._v(" (manuscript earlier seized in the mail)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1929")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("The Escaped Cock")]), _vm._v(" (Paris)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v("20 November 1929")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Last mention of his interest in the Etruscans")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("2 March 1930")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("Dies at Vence, Alpes Maritimes, France")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("September 1932")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Etruscan Places")]), _vm._v(" published by Martin Secker in England and Viking in America")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("November 1934")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_vm._v("'Germans and English' published as 'Tedeschi e Inglesi' in "), _c('em', {
    staticClass: "calibre4"
  }, [_vm._v("La Cultura")]), _vm._v(" (Turin)")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_row",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("19 October 1936")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Phoenix: The Posthumous Papers of D.H. Lawrence:")]), _vm._v(" contains 'Man is a Hunter', 'The Nightingale', 'Flowery Tuscany' I–III, 'David', 'Europe Versus America', 'Fireworks' (as 'Fireworks in Florence') and 'Flowery Tuscany' IV (as 'Germans and Latins')")])])]), _vm._v(" "), _c('tr', {
    staticClass: "t349_lastrow",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticClass: "c22",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("15 January 1968")]), _vm._v(" "), _c('td', {
    staticClass: "c23",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "jus"
  }, [_c('em', {
    staticClass: "calibre4"
  }, [_vm._v("Phoenix II: Uncollected, Unpublished and Other Prose Works by D. H. Lawrence:")]), _vm._v(" contains 'Germans and English'")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53c8b0cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0007.vue
// module id = 81
// module chunks = 0